export default __webpack_public_path__ + "static/silka-light-webfont-2500aee1d836029389d83497de45cab5.woff2";